import { useCallback, useContext } from 'react';
import ReportGadgetsContext from '../../../../contexts/ReportGadgetsContext';
import isUsedInChart from './isUsedInChart';

const useGetChartDefinitionUsage = () => {
  const { allGadgets } = useContext(ReportGadgetsContext);

  const getChartDefinitionUsage = useCallback(
    (
      metric: Metrics.NormalMetric | Metrics.CompoundMetric,
    ): VisualisationDefinition[] => {
      return allGadgets
        .map((g) => g.chartDef)
        .filter((def) => {
          return isUsedInChart(metric, def);
        });
    },
    [allGadgets],
  );

  return getChartDefinitionUsage;
};

export default useGetChartDefinitionUsage;
